import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  Grid,
  IconButton,
  Button,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAppTheme } from "../../theme/useAppTheme";

const Content = () => {
  const navigate = useNavigate();
  const { appConfig } = useSelector((state) => state.dashboard || {});
  const { customer } = useSelector((state) => state.profile || {});
  const Name = customer
    ? `${customer.firstName?.trim() || ""} ${customer.lastName?.trim() || ""}`
    : "";
  const initials = customer
    ? `${customer.firstName?.trim()[0] || ""}${
        customer.lastName?.trim()[0] || ""
      }`.toUpperCase()
    : "";
  const menuItems = appConfig?.content ?? [];
  const CDN_URL = process.env.REACT_APP_CDN_URL;
  const PACKAGE_NAME = process.env.REACT_APP_PACKAGE_NAME;

  const handleMenuClick = (title) => {
    const url = `${CDN_URL}/${PACKAGE_NAME}/static_data/${title.toLowerCase()}.html`;

    navigate("/webview", {
      state: {
        title: title,
        url: url,
      },
    });
  };

  const themeColors = useAppTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        p: { xs: 1.5, sm: 2 },
        background: themeColors.scaffoldGradientColors,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: 1350,
        mx: "auto",
        borderRadius: { xs: 0, md: "30px" },
        overflowX: "hidden",
      }}
    >
      {/* Profile Card */}
      <Card
        elevation={4}
        sx={{
          borderRadius: 4,
          mb: 3,
          cursor: "pointer",
        }}
        onClick={() => navigate("/Profile")}
      >
        <CardContent
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 1.5,
          }}
        >
          <Avatar
            sx={{
              width: 55,
              height: 55,
              background: "#ccc",
              color: themeColors.text,
            }}
          >
            {initials}
          </Avatar>

          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Typography fontWeight={700} fontSize={18} sx={{ wordBreak: "break-word" }}>
              {Name}
            </Typography>
            <Typography color="#4a73f3" fontSize={14}>
              View Your Account
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              px: 1.5,
              py: 0.5,
              borderRadius: 3,
              bgcolor: "#ffecec",
            }}
          >
            <Typography color="#d9534f" fontSize={14} fontWeight={600} mr={0.5}>
              Incomplete
            </Typography>
            <InfoOutlinedIcon sx={{ fontSize: 18, color: "#d9534f" }} />
          </Box>
        </CardContent>
      </Card>

      {/* Menu list */}
      <Box sx={{ flexGrow: 1 }}>
        {menuItems.map((item, index) => (
          <Box
            key={index}
            sx={{
              bgcolor: "rgba(87, 82, 82, 0.45)",
              backdropFilter: "blur(4px)",
              borderRadius: 4,
              p: 2,
              my: 1.2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: themeColors.text,
              cursor: "pointer",
            }}
            onClick={() => handleMenuClick(item)}
          >
            <Typography fontWeight={600}>{item}</Typography>
            <ChevronRightIcon />
          </Box>
        ))}
      </Box>

      {/* Logout button */}
      {/* <Button
        fullWidth
        sx={{
          mt: 3,
          py: 1.3,
          bgcolor: "#3b1689",
          color: "white",
          borderRadius: "25px",
          fontSize: 16,
          textTransform: "none",
          "&:hover": {
            bgcolor: "#2e0f6c",
          },
        }}
      >
        Logout ↪
      </Button> */}
    </Box>
  );
};

export default Content;
